export const TITLE = 'Organisation details';
export const DESCRIPTION = '';
export const DB_PREFIX = 'info';
